import React from 'react';
import { useLocale } from '@adsk/alloy-react-helpers';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import Theme from '@adsk/alloy-react-theme';

const NameInputFooter = () => {
  const { T } = useLocale(({ locale }) => require(`../../i18n/${locale}.json`));

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        height: '60px',
        justifyContent: 'center',
      }}
    >
      <AlertInformationIcon
        size={30}
        style={{ color: Theme.colors.charcoal700 }}
      />
      <div
        style={{
          width: '60%',
          textAlign: 'center',
          color: Theme.colors.charcoal700,
        }}
      >
        {T.translate('NAME_INPUT_FOOTER')}
      </div>
    </div>
  );
};

export default NameInputFooter;
